import { render } from "./PublicCreditPassport.vue?vue&type=template&id=59a064ea&scoped=true"
import script from "./PublicCreditPassport.vue?vue&type=script&lang=js"
export * from "./PublicCreditPassport.vue?vue&type=script&lang=js"

import "./PublicCreditPassport.vue?vue&type=style&index=0&id=59a064ea&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a064ea"]])

export default __exports__